export const selectEventId = (state) => state.eviteEvent?.id;
export const selectEventStartDateTime = (state) => state?.eviteEvent?.start_datetime;
export const selectEventStatus = (state) => state.eviteEvent?.status;
export const selectEventRsvpStyle = (state) => state.eviteEvent?.rsvp_style;
export const selectEventUsedAs = (state) => state.fabricTemplate?.usedAs ?? 'invitation';
export const selectEventRsvpOff = (state) =>
  state.details?.rsvp_off ?? state.eviteEvent?.rsvpOff ?? state.eviteEvent?.rsvp_off;
export const selectIsFabricPremium = (state) => !!state.eviteEvent?.is_fabric_premium;
export const selectEventGiftRegistry = (state) => !!state.eviteEvent?.gift_registry_name;
export const selectEventGiftRegistryUrls = (state) => !!state.eviteEvent?.gift_registry_urls;
